var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintTransparent = function SvgPrintTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M13 8.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m1-2.75V3.121a1.5 1.5 0 0 0-.44-1.06L11.94.439A1.5 1.5 0 0 0 10.878 0H3.953C3.426 0 3 .448 3 1v4.5A2.5 2.5 0 0 0 .5 8v4a.5.5 0 0 0 .5.5h2v3a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3h2a.5.5 0 0 0 .5-.5V8A2.5 2.5 0 0 0 14 5.5m-9.5-4h6V3a.5.5 0 0 0 .5.5h1.5v2h-8zm8 13h-8v-2h8zM15 11H2V8c0-.551.449-1 1-1h11c.551 0 1 .449 1 1z"
  })));
};
export default SvgPrintTransparent;